import apiClient from './apiClient';

const categoriesService = {
  // Get all categories for current authenticated user
  getMerchantCategories: async () => {
    // Session-based: uses authenticated user from req.user
    const response = await apiClient.get('/products/categories');
    return response.data;
  },
  
  // Create category
  createCategory: async (data) => {
    const response = await apiClient.post('/products/categories', data);
    return response.data;
  },
  
  // Update category
  updateCategory: async (categoryId, data) => {
    const response = await apiClient.put(`/products/categories/${categoryId}`, data);
    return response.data;
  },
  
  // Delete category
  deleteCategory: async (categoryId) => {
    const response = await apiClient.delete(`/products/categories/${categoryId}`);
    return response.data;
  }
};

export default categoriesService;